<template>
    <div class="home">
        列表
        <ul>
            <li
               v-for="(item,index) in list"
                :key="index"
                @click="routerPush(item.id)">
                {{item}}
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "collegeList",
        props: {

        },
        data() {
            return {
                list: []
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            getList() {
                axios({
                    method: 'get',
                    url: 'http://192.168.124.15:82/list',

                }).then(res => {
                    console.log(res);
                    this.list = res.data.data;
                })
            },
            routerPush(id) {
                this.$router.push({
                    name: 'calendarYSummary',
                    query: {
                        id: id
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    li{
        border: 1px solid red;
    }
</style>